export { CheckemailPageTemplate } from "./checkemail-page.template";
export { CheckemailPageTemplate as default } from "./checkemail-page.template";
